// 文档: https://cloud.tencent.com/document/product/266/14424
import React, { useState, useEffect, useRef } from 'react';
import S from './tcplayer.module.less';

const Player = window.TCPlayer;
let ID = 0;

const modeType = {
  lite: {
    controlBar: {
      fullscreenToggle: false,
      playbackRateMenuButton: false,
      QualitySwitcherMenuButton: false,
    }
  },
  complete: {
    plugins:{
      ContinuePlay: { // 开启续播功能
        // auto: true, // [可选] 是否在视频播放后自动续播
        text:'上次播放至 ', //[可选] 提示文案
        btnText: '恢复播放' //[可选] 按钮文案
      },
    },
  }
}

function TcPlayer({ mode, fileId }) {
  const [thisId] = useState(ID++);
  const container = useRef(null);
  
  useEffect(() => {
    const videoHTML = `
      <video
        playsinline
        preload='auto'
        webkit-playsinline
        class='${S.playerSize}'
        id='player-container-${thisId}'
      />
    `;

    container.current.innerHTML = videoHTML;
    Player(`player-container-${thisId}`, { // player-container-id 为播放器容器ID，必须与html中一致
      fileID: fileId, // 请传入需要播放的视频filID 必须
      appID: '1258515046', // 请传入点播账号的appID 必须
      ...modeType[mode],
    });

    return () => {
      // player.dispose();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fileId])

  return (
    <div ref={container} className={S.playerContainer}>

    </div>
  )
}

TcPlayer.defaultProps = {
  mode: 'lite',
  fileId: '',
}
// class TcPlayer extends Component {
//   static defaultProps = {
//     mode: 'lite', // lite complete
//   }
//   render() {
//     return (
//       <div ref={this.container} className={S.playerContainer}>

//       </div>
//     )
//   }

//   // 文档: https://cloud.tencent.com/document/product/266/14603
//   mode = {
//     lite: {
//       controlBar: {
//         fullscreenToggle: false,
//         playbackRateMenuButton: false,
//         QualitySwitcherMenuButton: false,
//       }
//     },
//     complete: {
//       plugins:{
//         ContinuePlay: { // 开启续播功能
//           // auto: true, //[可选] 是否在视频播放后自动续播
//           text:'上次播放至 ', //[可选] 提示文案
//           btnText: '恢复播放' //[可选] 按钮文案
//         },
//       },
//     }
//   }
//   id = ID++;
//   player = null;
//   container = React.createRef();
//   componentDidMount() {
//     const videoHTML = `
//       <video
//         playsinline
//         preload='auto'
//         class='${S.playerSize}'
//         webkit-playsinline
//         id='player-container-${this.id}'
//       />
//     `;
//     this.container.current.innerHTML = videoHTML;
//     const { fileId, mode } = this.props;
//     this.player = Player(`player-container-${this.id}`, { // player-container-id 为播放器容器ID，必须与html中一致
//       fileID: fileId, // 请传入需要播放的视频filID 必须
//       appID: '1258515046', // 请传入点播账号的appID 必须
//       ...this.mode[mode],
//     });
//   }

//   componentWillUnmount() {
//     this.player.dispose()
//   }
// }

export default TcPlayer;
